<p class="affinities-intro">{{ 'editorial.affinities_intro' | translate }}</p>

<!--
  Tiles, like the character block, and glossed like them too: the glyph sits whole above the
  term with the family named beside it, so "Pescado ahumado" is legible as a fish dish to a
  guest who has never met that vocabulary. Only the drawing is decorative — the family name is
  read out.
-->
<ul class="affinities">
    @for (affinity of visible(); track affinity.code) {
        <li class="affinity" [attr.data-group]="affinity.iconKey">
            <span class="affinity-top">
                <span class="affinity-mark" aria-hidden="true">
                    <app-group-icon [group]="affinity.iconKey" [size]="38"></app-group-icon>
                </span>
                @if (affinity.groupName) {
                    <i class="affinity-group">{{ affinity.groupName }}</i>
                }
            </span>

            <span class="affinity-label">{{ affinity.label }}</span>
        </li>
    }
</ul>
